import ReactOnRails from 'react-on-rails';
import ListViewWrapper from "../bundles/ListView/ListViewWrapper";
import '../src/styles/list-view.sass';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ ListViewWrapper });
